export default {
  apiKey: "AIzaSyBve7ZX5-NV_BYXwkHDJd1dzHawj0mJGHM",
  authDomain: "tgc-cloud.firebaseapp.com",
  projectId: "tgc-cloud",
  storageBucket: "tgc-cloud.appspot.com",
  messagingSenderId: "187363334268",
  appId: "1:187363334268:web:85397016d9f0d74abf51f9",
  measurementId: "G-103VGYHBFK"
};